import { Toast } from "primereact/toast";
import { Form } from "./Form";
import { IPermissionProps } from "../../models/Login";
import { useRef, useState } from "react";
import { Table } from "./Table";



export const AllocateTeamMast = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false })
    };

    return (
        <>
            {(permissions.is_Create || permissions.is_Update) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>}
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}